<template>
    <v-col class="py-0 pt-2">
        <div class="d-flex">
            <v-icon color="black" class="mr-2">mdi-cellphone</v-icon>
            <p class="subtitle-2 mt-1 mb-0">Phone Number</p>
        </div>
        <div class="d-flex justify-space-between">
            <p class="subtitle-1 mb-0 font-weight-bold">{{ recipientInfo.phone }}</p>
            <v-btn
                @click="copyToClipboard(recipientInfo.phone)"
                absolute
                x-small
                class="warning copy-button mt-1"
            >
                Copy
            </v-btn>
        </div>
    </v-col>
</template>

<script>
    export default {
        props: {
            recipientInfo: Object
        }
    }
</script>
